import React from 'react'
import {DatasContext} from './datas/DatasContext';
import identity from './datas/identity';
import content from './datas/content';
import {ThemePalette} from './components/ThemePalette';
import Header from './components/Header';
import Scrollable from './components/Scrollable';
import Mouse from './components/Mouse';
import LangSelector from './components/LangSelector';

import {I18nextProvider} from "react-i18next";
import i18next from "i18next";

function App() {
  return (
    <I18nextProvider i18n={i18next}>  
      <DatasContext.Provider value={{identity:identity, content:content}}>
        <ThemePalette>
          <Header/>
          <LangSelector />
          <Scrollable id="home"/>
          <Mouse/>
        </ThemePalette>
      </DatasContext.Provider>
    </I18nextProvider>
  );
}

export default App;
